import Sidebar from "../../components/sidebar/Sidebar";
import React from "react";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import TeamManagementHome from "./components/TeamManagementHome";

const TeamManagement = () => {
  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title="Team Management"  />
       

        {/* Table structure for jQuery DataTable */}

        <DatatableSection>
          <TeamManagementHome />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default TeamManagement;
